
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/zebra/page/[id]",
      function () {
        return require("private-next-pages/cases/zebra/page/[id].tsx");
      }
    ]);
  